// Percorso "I 4 compiti dei soldi": segna una tappa come completata.
// La chiave e' condivisa col check-up (stesso dominio): la pagina risultati
// legge lo stesso localStorage per mostrare i progressi nel tab mini corso.
const STORAGE_KEY = 'pills_course_progress_v1';

function readProgress() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch (error) {
    return {};
  }
}

function writeProgress(progress) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
  } catch (error) {
    // storage pieno o bloccato: il bottone resta solo visuale
  }
}

function renderState(button, done) {
  button.classList.toggle('is-done', done);
  button.innerHTML = done
    ? '<i class="check" aria-hidden="true">✓</i> Tappa completata · tocca per togliere il segno'
    : 'Segna questa tappa come completata';
}

const button = document.getElementById('courseCompleteToggle');
if (button && button.dataset.slug) {
  const slug = button.dataset.slug;
  renderState(button, Boolean(readProgress()[slug]));
  button.addEventListener('click', () => {
    const progress = readProgress();
    if (progress[slug]) {
      delete progress[slug];
    } else {
      progress[slug] = Date.now();
    }
    writeProgress(progress);
    renderState(button, Boolean(progress[slug]));
  });
}
